import { createSlice } from "@reduxjs/toolkit";
import { Socket } from "socket.io-client";
import { liveRoomDetails, liveRoomResponseType } from "@/types/common";
import { tokenType, UserDataType } from "@/types/global";

export interface initLoginState {
  liveRoomSocket?: Socket;
  liveRoomDetails?: liveRoomDetails;
  currProfile?: UserDataType;
  currToken?: tokenType;
  priorityStream?: liveRoomResponseType;
}

const initLoginState: initLoginState = {
  liveRoomSocket: undefined,
  liveRoomDetails: undefined,
  currProfile: undefined,
  currToken: undefined,
  priorityStream: undefined,
};
const liveRoomReducer = createSlice({
  name: "LiveRoom",
  initialState: initLoginState,
  reducers: {
    setLiveRoomSocket: (loginState, action) => {
      const socket = action.payload;
      return { ...loginState, liveRoomSocket: socket };
    },
    setLiveRoomDetails: (loginState, action) => {
      const details = action.payload;
      return { ...loginState, liveRoomDetails: details };
    },
    resetLiveRoomDetails: (loginState) => {
      return { ...loginState, liveRoomDetails: undefined };
    },
    setCurrProfile: (loginState, action) => {
      const profile = action.payload;
      return { ...loginState, currProfile: profile };
    },
    setCurrToken: (loginState, action) => {
      const profile = action.payload;
      return { ...loginState, currToken: profile };
    },
    setPriorityStream: (loginState, action) => {
      const stream = action.payload;
      return { ...loginState, priorityStream: stream };
    },
  },
});

export const {
  setLiveRoomSocket,
  resetLiveRoomDetails,
  setLiveRoomDetails,
  setCurrProfile,
  setCurrToken,
  setPriorityStream,
} = liveRoomReducer.actions;
// export default reducer;
export default liveRoomReducer.reducer;
